import React from 'react'
import classNames from 'classnames'
import './BlurText.css'

const BlurText = ({ children, hovered, active }) => {
  return (
    <span
      className={classNames('g-blur-txt', {
        'g-blur-hovered': hovered || active,
      })}
    >
      {children}
    </span>
  )
}

export default BlurText
